"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBMIT_BUTTON = exports.STATUS_RESOLVED = exports.STATUS_PENDING = exports.STATUS_IDLE = exports.SEND_EMAIL_BUTTON = exports.QUOTE_START = exports.QUOTE_COMPLETE = exports.PURCHASE = exports.MALE_GENDER_ID = exports.MALE_GENDER = exports.FREQUENCY_MONTHLY = exports.FREQUENCY_FORTNIGHTLY = exports.FREQUENCY_CODE_MONTHLY = exports.FREQUENCY_CODE_FORTNIGHTLY = exports.FREQUENCY_CODE_ANNUALLY = exports.FREQUENCY_ANNUALLY = exports.FEMALE_GENDER_ID = exports.FEMALE_GENDER = exports.DOG_SPECIES_CODE = exports.DOG_SPECIES = exports.CAT_SPECIES_CODE = exports.CAT_SPECIES = exports.CANCEL_BUTTON = void 0;
var CAT_SPECIES = exports.CAT_SPECIES = 'Cat';
var DOG_SPECIES = exports.DOG_SPECIES = 'Dog';
var CAT_SPECIES_CODE = exports.CAT_SPECIES_CODE = 'FELINE';
var DOG_SPECIES_CODE = exports.DOG_SPECIES_CODE = 'CANINE';
var MALE_GENDER = exports.MALE_GENDER = 'Male';
var FEMALE_GENDER = exports.FEMALE_GENDER = 'Female';
var MALE_GENDER_ID = exports.MALE_GENDER_ID = 2;
var FEMALE_GENDER_ID = exports.FEMALE_GENDER_ID = 1;
var STATUS_RESOLVED = exports.STATUS_RESOLVED = 'resolved';
var STATUS_IDLE = exports.STATUS_IDLE = 'idle';
var STATUS_PENDING = exports.STATUS_PENDING = 'pending';
var FREQUENCY_MONTHLY = exports.FREQUENCY_MONTHLY = 'Monthly';
var FREQUENCY_ANNUALLY = exports.FREQUENCY_ANNUALLY = 'Annually';
var FREQUENCY_FORTNIGHTLY = exports.FREQUENCY_FORTNIGHTLY = 'Fortnightly';
var FREQUENCY_CODE_MONTHLY = exports.FREQUENCY_CODE_MONTHLY = 'MONTHLY';
var FREQUENCY_CODE_FORTNIGHTLY = exports.FREQUENCY_CODE_FORTNIGHTLY = 'FORTNIGHTL';
var FREQUENCY_CODE_ANNUALLY = exports.FREQUENCY_CODE_ANNUALLY = 'ANNUALLY';
var QUOTE_START = exports.QUOTE_START = 'quote_start';
var QUOTE_COMPLETE = exports.QUOTE_COMPLETE = 'quote_complete';
var PURCHASE = exports.PURCHASE = 'purchase';
var SUBMIT_BUTTON = exports.SUBMIT_BUTTON = 'submitButton';
var CANCEL_BUTTON = exports.CANCEL_BUTTON = 'cancelButton';
var SEND_EMAIL_BUTTON = exports.SEND_EMAIL_BUTTON = 'sendEmailButton';